module.exports = __webpack_public_path__ + "ux.5a36812b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/chatbotmakers/ux.png
// module id = 926
// module chunks = 0